module.exports = __webpack_public_path__ + "static/2_pay-6a60bc1460dad27c78db87450aaececc.png";